package team.platforma.multiplatform_material_extension.tooltips

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.absoluteOffset
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Popup
import team.platforma.multiplatform_material_extension.getScreenSize
import team.platforma.multiplatform_material_extension.tooltips.model.PopupPosition

@Composable
fun TooltipPopup(
    text: String,
    positionIn: Offset,
    positionOut: Offset,
    contentSize: IntSize,
    popupPosition: PopupPosition
) {
    val triangleSize = 12.dp
    val triangleSizePx = with(LocalDensity.current) { triangleSize.toPx() }
    var boxSize by remember { mutableStateOf(IntSize.Zero) }
    var isMeasured by remember { mutableStateOf(false) }

    val rightOffset = positionIn.x + positionOut.x
    val distToLeft =
        with(LocalDensity.current) { getScreenSize().first.dp.toPx() } - rightOffset.toInt()

    val distToolTipToCenter = if (distToLeft < boxSize.width) {
        boxSize.width - distToLeft
    } else 0f
    Popup(
        offset = IntOffset(
            x = 0, y = when (popupPosition) {
                PopupPosition.TOP -> -contentSize.height / 2
                PopupPosition.BOTTOM -> contentSize.height
            }
        )
    ) {
        Column(
            horizontalAlignment = Alignment.Start,
        ) {
            // Если тултип СНИЗУ (стрелка должна быть сверху)
            if (popupPosition == PopupPosition.BOTTOM && isMeasured) {
                Triangle(
                    isUp = true,
                    color = TooltipStyle.getBgColor(),
                    offsetX = if (distToolTipToCenter == 0f)
                        (positionIn.x - triangleSizePx / 2).toInt()
                    else
                        (distToolTipToCenter + triangleSizePx).toInt()
                )
            }
            Box(
                modifier = Modifier
                    .background(color = TooltipStyle.getBgColor(), shape = TooltipStyle.getShape())
                    .padding(horizontal = 8.dp, vertical = 6.dp)
                    .onSizeChanged { size ->
                        boxSize = size
                        isMeasured = true
                    }

            ) {
                Text(
                    text = text,
                    style = TooltipStyle.getTextStyle(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }

            // Если тултип СВЕРХУ (стрелка должна быть снизу)
            if (popupPosition == PopupPosition.TOP && isMeasured) {
                Triangle(
                    isUp = false,
                    color = TooltipStyle.getBgColor(),
                    offsetX = if (distToolTipToCenter == 0f)
                        (positionIn.x - triangleSizePx / 2).toInt()
                    else
                        (distToolTipToCenter + triangleSizePx).toInt()
                )
            }
        }
    }
}

@Composable
fun Triangle(isUp: Boolean, offsetX: Int, color: Color) {
    val triangleSize = 11.3.dp // размер гипотенузы, чтоб катеты были по 8
    Box(
        modifier = Modifier
            .absoluteOffset { IntOffset(x = offsetX, y = 0) }
            .size(width = triangleSize, height = triangleSize/2)
    ) {
        Canvas(modifier = Modifier.fillMaxSize()) {
            drawPath(
                path = Path().apply {
                    if (isUp) {
                        // стрелка вверх
                        moveTo(size.width / 2f, 0f)
                        lineTo(0f, size.height)
                        lineTo(size.width, size.height)
                    } else {
                        // стрелка вниз
                        moveTo(size.width / 2f, size.height)
                        lineTo(0f, 0f)
                        lineTo(size.width, 0f)
                    }
                    close()
                },
                color = color
            )
        }
    }
}

